import {
  FloatingFormItem,
  InputDate,
  PlanAccountsSelect,
} from '@/components/_common';
import {
  PlanAccountDestination,
  PlanAccountHierarchy,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { InstallmentReverseFormValues } from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Col, Form, Modal, ModalProps, Row } from 'antd';
import moment from 'moment';

import React from 'react';

interface Props extends Omit<ModalProps, 'onOk'> {
  isLoading?: boolean;
  onCallBackValues: (values?: InstallmentReverseFormValues) => void;
  onCancel: () => void;
}

const ReverseInstallmentModal: React.FC<Props> = ({
  onCallBackValues,
  onCancel,
  open,
  isLoading,
}) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const [form] = Form.useForm<InstallmentReverseFormValues>();

  const today = moment().format('YYYY-MM-DD');
  const reversalDate = Form.useWatch('reversalDate', form);

  const isEarlierDate = moment(reversalDate).isBefore(today);

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleOk = async () => {
    await onCallBackValues(form.getFieldsValue());

    form.resetFields();
  };

  return (
    <Modal
      width={860}
      open={open}
      onCancel={handleCancel}
      title={'Estorno'}
      footer={[
        <Button type="primary" ghost onClick={onCancel}>
          Cancelar
        </Button>,
        <Button
          type="primary"
          loading={isLoading}
          onClick={handleOk}
          disabled={
            isEarlierDate &&
            !hasPermissions([
              Authorities.FINANCIAL_ACCOUNT_PAYABLE_SETTLE_REFUND_WITH_PREVIOUS_DATE,
            ])
          }
        >
          Estornar
        </Button>,
      ]}
      destroyOnClose
    >
      <Form form={form}>
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <FloatingFormItem
              name={'planAccountId'}
              label={'Plano de contas'}
              rules={[defaultEmptyFieldError]}
            >
              <PlanAccountsSelect
                queryFilter={{
                  active: true,
                  hierarchy: PlanAccountHierarchy.Analitical,
                  destination: PlanAccountDestination.Revenue,
                }}
              />
            </FloatingFormItem>
          </Col>

          <Col span={5}>
            <FloatingFormItem
              name={'reversalDate'}
              label={'Data de estorno'}
              rules={[defaultEmptyFieldError]}
              initialValue={moment()}
            >
              <InputDate />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ReverseInstallmentModal;
